import { useSelector } from "react-redux"
import { associateFT } from "../Hashconnect"
import { getUserData, notifyAssociation } from "../services/API"

function FTRewards({ setLoading, setIsClaimSuccessful, setIsAssociationSuccessful }: any) {
    const isThirdTierAssociated = useSelector((state: any) => state.user.isThirdTierAssociated)
    const isThirdTierOwner = useSelector((state: any) => state.user.isThirdTierOwner)
    const isFourthTierAssociated = useSelector((state: any) => state.user.isFourthTierAssociated)
    const isFourthTierOwner = useSelector((state: any) => state.user.isFourthTierOwner)
    const isFifthTierAssociated = useSelector((state: any) => state.user.isFifthTierAssociated)
    const isFifthTierOwner = useSelector((state: any) => state.user.isFifthTierOwner)
    const FTStatus = useSelector((state: any) => state.user.FTStatus)
    const isFounder = useSelector((state: any) => state.user.isFounder)
    const isConnected = useSelector((state: any) => state.user.isConnected)

    async function associateToken({ setLoading, setIsClaimSuccessful, setIsAssociationSuccessful }: any) {
        try {
            // console.log("cargando")
            setLoading(true)
            await associateFT(setIsClaimSuccessful);
            setTimeout(async () => {
                await getUserData()
              }, 2000);
            setLoading(false)
        } catch (error) {

        }
    }

    async function claimFTTokens() {
        setLoading(true)
        await notifyAssociation(setIsClaimSuccessful);
        await getUserData()
        setLoading(false)
    }

    return (
        <>
            {/* {
                (isFifthTierAssociated
                    && isFifthTierOwner
                    && isFourthTierOwner
                    && isFourthTierAssociated
                    && isThirdTierOwner
                    && isThirdTierAssociated
                    && isFounder
                    && FTStatus === 'CLAIMED')
                    ?
                    <>
                        <div className="reward rewardFoundersToken claimed">
                            <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                            <div className="rewardImage"></div>
                            <div className="btnRewards">CLAIMED<span className="icoLocked material-symbols-outlined">lock</span></div>
                        </div>
                    </>
                    :
                    (isFifthTierAssociated
                        && !isFifthTierOwner
                        && !isFourthTierOwner
                        && isFourthTierAssociated
                        && !isThirdTierOwner
                        && isThirdTierAssociated
                        && isFounder
                        && FTStatus === 'CREATED')
                        ?
                        <>
                            <div className="reward rewardFoundersToken claimed">
                            <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                <div className="rewardImage"></div>
                                <div className="btnRewards claimed">PROCESSING... <span className="icoProgress material-symbols-outlined">timer_3_alt_1</span></div>
                            </div>
                        </>
                        :
                        (isFifthTierAssociated
                            && !isFifthTierOwner
                            && !isFourthTierOwner
                            && isFourthTierAssociated
                            && !isThirdTierOwner
                            && isThirdTierAssociated
                            && isFounder
                            && FTStatus === 'Not Claimed')
                            ?
                            <>
                                <div className="reward rewardFoundersToken NotClaimed">
                                <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                    <div className="rewardImage"></div>
                                    <div className="btnRewards" onClick={claimFTTokens}>CLAIM <span className="icoTask material-symbols-outlined">emoji_events</span></div>
                                </div>
                            </>
                            :
                            (!isFifthTierAssociated
                                && !isFifthTierOwner
                                && !isFourthTierOwner
                                && !isFourthTierAssociated
                                && !isThirdTierOwner
                                && !isThirdTierAssociated
                                && isFounder)
                                ?
                                <>
                                    <div className="reward rewardFoundersToken notClaimed">
                                    <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                        <div className="rewardImage"></div>
                                        <div className="btnRewards" onClick={associateToken}>ASSOCIATE TOKENS  <span className="icoProgress material-symbols-outlined">settings_alert</span></div>
                                    </div>
                                </>
                                :
                                (isFifthTierAssociated === false
                                    && isFifthTierOwner === false
                                    && isFourthTierOwner === false
                                    && isFourthTierAssociated === false
                                    && isThirdTierOwner === false
                                    && isThirdTierAssociated === false
                                    && isFounder === false
                                    && isConnected === true)
                                    ?
                                    <>
                                        <div className="reward rewardFoundersToken claimed">
                                        <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                            <div className="rewardImage"></div>
                                            <div className="btnRewards claimed">LOCKED <span className="icoLocked material-symbols-outlined">lock</span></div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="reward rewardFoundersToken claimed">
                                        <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                            <div className="rewardImage"></div>
                                            <div className="btnRewards claimed">LOCKED <span className="icoLocked material-symbols-outlined">lock</span></div>
                                        </div>
                                    </>
            } */}
                <>
                                        <div className="reward rewardFoundersToken claimed">
                                        <span className="rewardsTitle">Found<span>e</span>rs Tok<span>e</span>n R<span>e</span>ward</span>
                                            <div className="rewardImage"></div>
                                            <div className="btnRewards claimed">LOCKED <span className="icoLocked material-symbols-outlined">lock</span></div>
                                        </div>
                                    </>
        </>
    );
}

export default FTRewards;